import React, { Fragment } from 'react';
import BlogSection from '../../components/BlogSection/BlogSection';
import BusSection from '../../components/BusSection/BusSection';
import CoupleSection from '../../components/CoupleSection/CoupleSection';
import CtaSection from '../../components/CtaSection/CtaSection';
import EventSection from '../../components/EventSection/EventSection';
import Footer from '../../components/footer/Footer';
import Hero5 from '../../components/hero5/Hero5';
import Navbar2 from '../../components/Navbar2';
import RSVP from '../../components/RSVP';
import Scrollbar from '../../components/scrollbar';
import StorySection from '../../components/StorySection/StorySection';
import PwSection from '../../components/PreWeddingSection/PwSection';
import GiftSection from '../../components/Gift/GiftSection';
import HairSection from '../../components/HairSection/HairSection';
import InfoSection from '../../components/Info/InfoSection';
import HotelSection from '../../components/Hotel/HotelSection';



const HomePage =() => {

    return(
        <Fragment>
            <Navbar2/>
            <Hero5/>
            {/* <br></br> */}
            {/* <WeddingTime/> */}
            {/* <CoupleSection/> */}
            {/* <VideoSection/> */}
            <StorySection/>
            <EventSection/>
            <PwSection/>
            <CtaSection/>
            {/* <PortfolioSection/> */}
            <RSVP pt={'section-padding pt-200'}/>
            <HotelSection/>
            <BusSection/>
            <HairSection></HairSection>
            <GiftSection></GiftSection>
            {/* <BrideGrooms/> */}
            {/* <PartnerSection/> */}
            {/* <BlogSection/> */}
            {/* <Footer/> */}
            <InfoSection/>
            <Scrollbar/>
        </Fragment>
    )
};

export default HomePage;